import React from "react";

import Popup from "./Popup";
import { CButton, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";
import { MessageSquare, Phone } from "react-feather";

const PopupOutOfDateCustomers = props => {
  const { trigger, setTrigger } = props;

  return (
    <Popup title="Clientes desatualizados" trigger={trigger} setTrigger={setTrigger} width="750">
      <div className="x-p-20 pt-10 pb-10">
        <CTable hover>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell scope="col">
                <span className="text-color">
                  Nome
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col">
                <span className="text-color">
                  Lote
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell scope="col" width="34.5"></CTableHeaderCell>
              <CTableHeaderCell scope="col" width="34.5"></CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            <CTableRow>
              <CTableDataCell align="middle">
                <span className="text-color">
                  Lucas Bueno
                </span>
              </CTableDataCell>
              <CTableDataCell align="middle">
                <span className="text-color">
                  TRATOR VALMET 65 ANO 1979 LOTE 87279
                </span>
              </CTableDataCell>
              <CTableDataCell align="middle">
                <span className="text-color">
                  <CButton color="primary" size="sm">
                    <MessageSquare />
                  </CButton>
                </span>
              </CTableDataCell>
              <CTableDataCell align="middle">
                <span className="text-color">
                  <CButton color="success" size="sm">
                    <Phone color="#FFF" />
                  </CButton>
                </span>
              </CTableDataCell>
            </CTableRow>
          </CTableBody>
        </CTable>
      </div>
    </Popup>
  );
}

export default PopupOutOfDateCustomers;